import service, { post } from '@/utils/https'
import type { FaqCatalogImportRow, FaqPayload, FaqsListFilters } from '@/types/faq'

/** Query params for GET /faqs — array filters are sent as comma-separated strings. */
export type FaqsQueryParams = Omit<
  FaqsListFilters,
  'topics' | 'team_tag_ids' | 'team_unit_ids' | 'freelancer_ids'
> & {
  topics?: string | string[]
  team_tag_ids?: string | string[]
  team_unit_ids?: string | string[]
  freelancer_ids?: string | string[]
}

export const fetchFaqs = (params: FaqsQueryParams) =>
  service.get('/api/app/v1/faqs', { params })

export const createFaq = (payload: FaqPayload) => service.post('/api/app/v1/faqs', payload)

export const updateFaq = (faqId: string, payload: FaqPayload) =>
  service.put(`/api/app/v1/faqs/${faqId}`, payload)

export const deleteFaq = (faqId: string) => service.delete(`/api/app/v1/faqs/${faqId}`)

export const importFaqs = (rows: FaqCatalogImportRow[]) =>
  post('/api/app/v1/faqs/import', { rows }, { hideMessageModal: true })
